import EnumClass, { build } from '../EnumClass';
import data, { SubscriptionStateId, SubscriptionStateData } from './data';
import * as Translations from './translations';

export class SubscriptionState extends EnumClass<SubscriptionStateId, SubscriptionStateData> {
  public get getName() {
    return Translations.name[this.id];
  }

  public get getDescription() {
    return Translations.description[this.id];
  }
}

export const {
  list: SUBSCRIPTION_STATES,
  getById: getSubscriptionStateById,
  marshaller: SubscriptionStateMarshaller,
} = build<SubscriptionStateId, SubscriptionStateData, SubscriptionState>(
  'SubscriptionStateEnum',
  data,
  SubscriptionState,
);
